<template>
  <div class="bg-white" style="width:100vw;height:100vh;overflow: hidden">
    <div :style="{backgroundImage:'url('+ IMG_BASE_URL + '/banner_bg.jpg)'}" style="height:124px;background-size: cover;background-position: center;background-repeat: no-repeat;"
         class="flex justify-between padding-right padding-left-xl align-center">
      <div>
        <img :src="IMG_BASE_URL + '/zxzdxtHeader.png'" height="80"/>
      </div>
      <div v-if="appCode !== 'zgrd'" class="text-df text-right padding-top-lg">
        <img :src="IMG_BASE_URL + '/zxzdxt_right.png'" width="532" height="60"/>
      </div>
    </div>
    <div class="footer flex align-center text-center bg-gray">
      <div style="width:100vw">
        <div>{{footerInfo.customPhone}}<span v-if="footerInfo.adLine" style="padding-left: 20px">{{footerInfo.adLine}}</span><span v-if="footerInfo.bookLine" style="padding-left: 20px">{{footerInfo.bookLine}}</span><span v-if="footerInfo.afterSalePhone" style="padding-left: 20px">{{ footerInfo.afterSalePhone}}</span></div>
        <div class="padding-top-sm">{{ copyright }}<span v-if="icp" style="padding-left: 20px"></span>{{ icp }}</div>
      </div>
    </div>
<!--    <div class="flex justify-center align-center" style="padding-top: 110px">-->
<!--      <div style="font-size:35px;font-weight: bold;color: #ed1c24">本平台为互联网非涉密平台,严禁处理传输国家秘密</div>-->
<!--    </div>-->
    <div class="flex justify-center align-center" style="padding-top: 120px">
      <div>
        <img :src="IMG_BASE_URL + '/pcHome.jpg'" width="570" height="344"/>
      </div>
      <div class="padding-xl"></div>
      <div class="padding-xl bg-white shadow-warp" style="width:250px">
        <div>
          <div class="text-center text-bold text-xxl text-black padding-bottom">订户登录</div>
          <div class="input-login flex align-center text-xl">
            <i class="cuIcon-mobile text-red"></i>
            <input style="width:100%;" maxlength="11" placeholder="请输入11位手机号" v-model="loginObject.phone"/>
          </div>
          <div class="input-login flex align-center text-xl">
            <i class="cuIcon-lock text-red"></i>
            <input maxlength="6" placeholder="6位验证码" style="margin-right: 0;width: 80px;"
                   v-model="loginObject.captcha"/>
            <div class="text-right" :class="countdown === 60?'text-blue':'text-gray'"
                 style="width: 120px;font-size:15px;border-left: #ccc solid 1px;"
                 @click="sendCaptcha" :style="canSend()?'cursor: pointer':'cursor: not-allowed'">
              <span>{{ codeText }}</span>
            </div>
          </div>
        </div>
        <div class="input-btn input-login bg-red no-border" @click="login"
             :style="canPost()?'cursor: pointer':'cursor: not-allowed'">
          <span>登 录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bs from '@/services/data/bs'
import api from '@/services/data/api'
import config from '../../public/config/config'
import Cookies from 'js-cookie'

export default {
  name: 'login',
  data () {
    return {
      footerInfo: config.footer,
      copyright: config.copyright,
      icp: config.icp,
      appCode: config.APP_CODE,
      IMG_BASE_URL: config.IMG_BASE_URL,
      loginObject: {
        phone: '',
        captcha: ''
      },
      countdown: 60,
      codeText: '获取验证码'
    }
  },
  created () {
    this.appCode = config.APP_CODE
  },
  methods: {
    canPost () {
      return this.loginObject.phone.length === 11 && this.loginObject.captcha.length === 6
    },
    canSend () {
      return this.loginObject.phone.length === 11 && this.countdown === 60
    },
    sendCaptcha () {
      if (this.canSend()) {
        bs.user.code(this.loginObject.phone, this.loginObject.phone, (res) => {
          if (res.code === 200) {
            this.$message({
              message: '验证码发送成功',
              type: 'success'
            })
            this.countdown = 59
            this.setCountDown()
          } else if (res.code === 301) {
            this.$message.error('手机号码不正确')
          } else {
            this.$message.error('验证码发送失败')
          }
        })
      }
    },
    setCountDown: function () {
      setTimeout(() => {
        this.codeText = this.countdown + '秒后重试'
        this.countdown--
        if (this.countdown === 0) {
          this.codeText = '获取验证码'
          this.countdown = 60
        } else {
          this.setCountDown()
        }
      }, 1000)
    },
    login () {
      if (this.canPost()) {
        bs.user.login(this.loginObject.phone, this.loginObject.captcha, (res) => {
          if (res.code === 200) {
            Cookies.set(api.tokenKey, res.data.token)
            this.$message({
              message: '登录成功',
              type: 'success'
            })
            sessionStorage.setItem('user', JSON.stringify(res.data))
            this.$router.push({ path: '/pages/subscribe/mode' })
          } else {
            this.$message.error('登录失败')
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.header {
  height: 100px;
  width: 100vw;
}

.footer {
  position: absolute;
  bottom: 0;
  height: 80px;
  width: 100vw;
  background-color: #232323;
  color: white;
  z-index: 1000;
}

.input-login {
  height: 36px;
  padding: 0 20px;
  border: #b70d0e solid 1px;
  border-radius: 20px;
  margin-bottom: 10px;
}

.input-login input {
  height: 32px;
  line-height: 32px;
  margin-left: 10px;
  border: none;
  outline: none;
  font-size: 14px;
}

.bg-gray-1 {
  background-color: #999;
  color: #fff;
}

.input-btn {
  height: 42px;
  margin-top: 30px;
  font-size: 18px;
  text-align: center;
  line-height: 40px;
  border: none !important;
}

</style>
